import { CheckCircle2, ArrowRight } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { Reveal, Img } from "./Reveal";
import { IMG } from "@/data/content";
import { scrollToId } from "@/lib/scroll";

const POINTS = [
  "Modern clinical environment",
  "Qualified doctors",
  "Patient-focused consultations",
  "Complete dental care",
  "Skin & dermatology services",
  "Standardized franchise ecosystem",
  "Growing network across India",
];

export function About() {
  return (
    <section id="about" data-testid="about-section" className="relative py-24 lg:py-32 bg-ivory overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
          <div className="relative order-2 lg:order-1">
            <Reveal>
              <div className="overflow-hidden rounded-[2rem] shadow-grand">
                <Img src={IMG.about} alt="Modern Dyntra Clinics interior" className="h-[420px] lg:h-[520px] w-full object-cover transition-transform duration-700 hover:scale-105" />
              </div>
            </Reveal>
            <Reveal delay={0.2} className="absolute -bottom-8 -right-4 md:-right-8 w-40 md:w-52">
              <div className="overflow-hidden rounded-2xl ring-4 ring-ivory shadow-lift">
                <Img src={IMG.clinicChair} alt="Dental treatment chair" className="h-40 md:h-48 w-full object-cover" />
              </div>
            </Reveal>
            <div className="absolute -top-6 -left-6 h-24 w-24 rounded-full border-2 border-dashed border-gold/50" />
          </div>

          <div className="order-1 lg:order-2">
            <SectionHeading
              chapter="01"
              overline="About Dyntra Clinics"
              title="Healthcare Built Around Trust, Expertise & Accessibility"
              sub="Dyntra Clinics is a growing healthcare franchise network focused on bringing professional dental and skin-care services closer to patients - through modern clinics, qualified doctors and a standardized ecosystem."
            />
            <Reveal delay={0.2}>
              <ul className="mt-8 grid sm:grid-cols-2 gap-x-6 gap-y-3">
                {POINTS.map((p) => (
                  <li key={p} className="flex items-start gap-2.5 text-sm font-semibold text-pine/80">
                    <CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0 text-teal-brand" />
                    {p}
                  </li>
                ))}
              </ul>
            </Reveal>
            <Reveal delay={0.3}>
              <button
                data-testid="about-discover-cta"
                onClick={() => scrollToId("clinics")}
                className="group mt-10 inline-flex items-center gap-2 rounded-full bg-pine px-7 py-3.5 text-sm font-bold text-ivory shadow-lift transition-all duration-300 hover:bg-pine-deep hover:-translate-y-0.5"
              >
                Discover Dyntra Clinics
                <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
              </button>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
